const projectFolder = import.meta.env.VUE_APP_PROJECT_NAME;
export default {
  // static images path
  base_url: import.meta.env.VUE_APP_BASE_URL,
  api_url: import.meta.env.VUE_APP_API_URL,
  // server images path
  server_url: import.meta.env.VUE_APP_SERVER_URL,

  // project name
  projectName: import.meta.env.VUE_APP_PROJECT_NAME,

  // this text use in footer
  projectFooterText: import.meta.env.VUE_APP_PROJECT_FOOTER_TEXT,

  // active questionnaire in azmoon
  activeQuestionnaireInAzmoon: import.meta.env
    .VUE_APP_ACTIVE_QUESTIONNAIRE_IN_AZMOON,

  // channel socket key
  channelSocketKey: import.meta.env.VUE_APP_CHANNEL_SOCKET_KEY,

  // public socket key
  enamadId: import.meta.env.VUE_APP_ENAMAD_ID,
  enamadCode: import.meta.env.VUE_APP_ENAMAD_CODE,

  // dynamic images path
  images: {
    logo: `/img/${projectFolder}/logo.png`,
    tinyLogo: `/img/${projectFolder}/tiny-logo.png`,
    adaptiveTrainingStaticImage:
      "/img/shared/adaptive-training-static-image.jpeg",
    shared: {
      bankLogo: {
        mellat: "/img/shared/bank-logo/mellat.png",
        zarinpal: "/img/shared/bank-logo/zarinpal.png",
      },
      besme: `/img/shared/besme.jpg`,
      noPerson: `/img/shared/no-person.jpg`,
      noImage: `/img/shared/no-image.png`,
      bossSeal: `/img/shared/boss-seal.png`,
      bossSignature: `/img/shared/boss-signature.png`,
      karshenasanSeal: `/img/shared/karshenasan-seal.png`,
      karshenasanSignature: `/img/shared/karshenasan-signature.png`,
      vekalatSeal: `/img/shared/vekalat-seal.png`,
      vekalatSignature: `/img/shared/vekalat-signature.png`,
      competencies: `/img/shared/competencies.png`,
      assessor: `/img/shared/assessor.png`,
      candidate: `/img/shared/candidate.png`,
      cartMeli: `/img/shared/cart-meli.jpg`,
      adaptiveTrainingCourseImage: `/img/shared/adaptive-training-course-image.svg`,
      redesign: {
        empty: {
          activeRegistrations:
            "/img/shared/redesign/empty/active-registrations.svg",
          resultRegistrations:
            "/img/shared/redesign/empty/result-registrations.svg",
          list: "/img/shared/redesign/empty/list.svg",
          noUser: "/img/shared/redesign/empty/no-user.svg",
          noImage: "/img/shared/redesign/empty/no-image.svg",
          reportList: "/img/shared/redesign/empty/report-list.svg",
          archive: "/img/shared/redesign/empty/archive.svg",
          history: "/img/shared/redesign/empty/history.svg",
          search: "/img/shared/redesign/empty/search.svg",
          exercisePrerequisite:
            "/img/shared/redesign/empty/exercise-prerequisite.svg",
          companyDefaultLogo:
            "/img/shared/redesign/empty/company-default-logo.svg",
          noInformation: "/img/shared/redesign/empty/no-information.svg",
          noHozehGhazayiDetail:
            "/img/shared/redesign/empty/no-hozeh-ghazayi-detail.svg",
          noNotification: "/img/shared/redesign/empty/no-notification.svg",
          noPreRegisterStep:
            "/img/shared/redesign/empty/no-pre-register-step.svg",
        },
        successCircle: "/img/shared/redesign/success-circle.svg",
        errorCircle: "/img/shared/redesign/error-circle.svg",
        emptyColumn: "/img/shared/redesign/empty-column.svg",
        noStartCase: "/img/shared/redesign/no-start-case.svg",
        messengers: {
          baleConnectIcon:
            "/img/shared/redesign/messengers/bale-connect-icon.svg",
          baleDisconnectIcon:
            "/img/shared/redesign/messengers/bale-disconnect-icon.svg",
        },
      },
    },
  },
  client: {
    grant_type: "password",
    client_id: "1",
    client_secret: "GumYWwaRs7C8qpL8jJV08uFFaCq4UrGshUKPZLBG",
    scope: "*",
  },
  rasa_company_code: "kVhlMrcYULmoEnVKdh1M9prw77Cxv97M",
  resources: {
    auth: "v1/auth",
    two_step: "v1/two_step",
    getMenu: "v1/menu",
    person: "v1/person",
    task: "v1/task",
    date: "v1/date",
    all_task: "v1/all_task",
    company: "v1/company",
    company_id: "v1/company/{0}",
    person_company: "v1/company/{0}/person",
    person_attachment: "v1/person/{0}/attachment",
    filter_cache_resource: "v1/filter_cache",
    attachment_confirm: "v1/{0}/{1}/attachment/{2}/confirm",
    attachment_change: "v1/{0}/{1}/attachment/{2}/change",
    company_person: "v1/person/{0}/company",
    attachment_type_combo: "v1/attachment_type_combo",
    person_address: "v1/person/{0}/address",
    person_contact: "v1/person/{0}/contact",
    company_address: "v1/company/{0}/address",
    company_contact: "v1/company/{0}/contact",
    profile: "v1/profile",
    import_person: "v1/import_person",
    province: "v1/province",
    province_city: "v1/province/{0}/city",
    enum: "v1/enum",
    enum_type: "v1/enum/{type}",
    activity_type: "v1/enum/activity_type",
    activity_time_checkpoint: "v1/enum/activity_time_checkpoint",
    user: "v1/user",
    user_id: "v1/user/{0}",
    user_info: "v1/user_info",
    upload_folder: "public/sample-excels", // without v1/
    user_change_pass: "v1/user/{0}/change_pass",
    users_two_step_change: "v1/system_config/3F0mpnuAVNNMA2iMuvAwRntFDR8h0D3u", // this code is hard coded just for two step config
    filter: "v1/filter/{0}",
    filter_module: "v1/{0}/filter/{1}",
    attachment_folder: "v1/attachment/folder",
    attachment_files: "v1/attachment/files/{0}/{1}",
    attachmentTemp: "v1/attachment_temp",
    resource_key_attachmentTemp: "v1/{0}/{1}/attachment_temp",
    attachmentUnlimited: "v1/{0}/{1}/attachment",
    attachment: "v1/{0}/{1}/attachment",
    attachment_wot: "v1/{0}/{1}/attachment_wt",
    person_content_data: "v1/{resource}/{key}/person_content",
    activity: "v1/{resource}/{key}/activity",
    report_id: "v1/report/{0}",
    report_settings: "v1/report_settings",
    report_settings_id: "v1/report_settings/{0}",
    report_settings_combo: "v1/report_settings_combo",
    report_resource: "v1/{0}/{1}/report",
    person_content: "v1/person_content",
    person_education: "v1/person/{0}/education",
    location: "v1/location",
    place: "v1/place",
    person_job_experience: "v1/person/{0}/job_experience",
    person_text: "v1/person/{0}/text",
    person_relation: "v1/person/{0}/relation",
    person_relation_paginate: "v1/person/{0}/relation_paginate",
    person_full_name: "v1/person/{0}/full_name",
    relation_person: "v1/person_relation",
    person_relation_code: "v1/person/{0}/person_relation",
    person_social_experience: "v1/person/{0}/social_experience",

    person_state: "v1/state/{0}",
    state: "v1/{0}/{1}/state",
    payment: "v1/payment",
    payment_melat_bank: "https://bpm.shaparak.ir/pgwchannel/startpay.mellat",
    payment_request: "v1/payment_request",
    state_group: "v1/state_group",
    state_define: "v1/state_define",
    sms: "v1/sms",
    faq: "v1/faq",
    attachment_files_woc: "v1/attachment_wot/files/{0}/{1}",
    azmoon_execute_report: "v1/azmoon_execute/{0}/report",
    action: "v1/action",
    exportData: "v1/export/{0}",
    azmoon_execute:
      "v1/azmoon_execute/{0}/person/{1}/operator/{2}/reference/{3}",
    tag: "v1/tag",
    attachment_crop: "v1/attachment/{0}/crop",
  },
  metaData: {
    gender: "v1/enum/gender",
    marriage: "v1/enum/marriage",
    contact_kind: "v1/enum/contact_kind",
    person_address_kind: "v1/enum/person_address_kind",
    company_address_kind: "v1/enum/company_address_kind",
    enum_parent: "v1/enum/parent/{0}",
    import_user: "import_user.xlsx",
    enum: "v1/enum",
    captcha: "captcha/api/math", // without v1/
    entity_enum_builder: "v1/enum/{entity}_{enum}",
  },
  form: {
    labelCol: 12,
    textareaRows: 1,
  },
  login: {
    verification_code_timeout: 300, // حداکثر زمان لازم برای ارسال کد اعتبارسنجی
    two_step_verification_timeout: 300, // حداکثر زمان لازم برای ارسال کد تایید دو مرحله ای
    backgournd_image_count: 2, // تعداد عکس‌های بک گراند صفحه ورود
    two_step_code_length: 4, // طول کد تایید
    verification_code_length: 4, // طول کد تایید
  },
  role_guard_name: "api",
  relation_type: {
    workForm: 2,
    education: 3,
    socialRevolutionary: 5,
    relativesform: 4,
    wifi_relation: 8,
    parentChildForm: 7,
  },
  profileServices: {
    parvandeh_status_count_incomplete: "v1/parvandeh/{0}/status",
    person_years_of_service: "v1/person/{0}/person_years_of_service",
    person_years_of_service_id: "v1/person/{0}/person_years_of_service/{1}",
  },
  globalServices: {
    reportSettingComboPaginate: "v1/report-setting-combo-paginate",
    user_info: "v1/user_info",
    menu: "v1/menu",
    peaks: "v1/attachment/{0}/peaks",
    frontErrorLog: "v1/front-error-log",
    tusAttachmentTemp: "v1/tus-attachment-temp",
    tusAttachment: "v1/tus-attachments",
    convertVoiveToText_code: "v1/attachment/{0}/voice_text",
    chatCompletions: "v1/chat/intelligence-processing",
    convertVoiceToText: "v1/convert-voice-to-text",
    myParvandeh: "v1/my_parvandeh",
    parvandehChangeRole: "v1/parvandeh_change_role",
    parvandeh_status_detail: "v1/parvandeh/{0}/status_detail",
    exportExcel: "v1/export/{0}",
    attachment_wot: "v1/{0}/{1}/attachment_wt",
    attachment_temp: "v1/attachment_temp",
    location_public: "v1/location_public",
    filter_id: "v1/filter/{0}",
    filter_module: "v1/{0}/filter/{1}",
    researcher_combo: "v1/researcher/{0}",
    mainUserInfo: "v1/main-user-info",
    filter_cache: "v1/filter_cache",
    term_combo: "v1/term_combo",
    user_combo: "v1/user-combo",
    researchPersonCombo: "v1/research_person",
    exercise_combo: "v1/exercise_combo",
    indicator_combo: "v1/indicator_combo",
    indicatorCategory: "v1/indicator-category-combo",
    evidence_combo: "v1/evidence_combo",
    report_settings_combo: "v1/report_settings_combo",
    company_combo: "v1/company/combo",
    researchManagerCombo: "v2/research_manager",
    azmoonExecuteCombo: "v1/azmoon_execute_combo",
    roleCombo: "v1/role/combo",
    termStateDefineCombo: "v1/term_state_define_combo",
    gate_combo: "v1/gate_combo",
    parvandehWithNationalCodeCombo: "v1/parvandeh-with-national-code-combo",
    candidatesCombo: "v1/candidates",
    assessor_combo: "v1/center_execute/{0}/assessor",
    assessmentPlanCombo: "v1/assessment_plan/combo",
    templateCombo: "v1/template/combo",
    executivesCombo: "v1/executives",
    termParvandehCombo: "v1/term/{0}/parvandeh",
    skillCombo: "v1/skill",
    termStateCombo: "v1/term_state_combo",
    parvandehCombo: "v1/parvandeh_combo",
    centerExecuteCombo: "v1/fa/kanoon/center-execute-combo",
    executivesWithNationalCode: "v1/executives-with-national-code",
    locationCombo: "v1/location",
    hozehGhazayiProvince: "v1/hozeh-ghazayi-province/{0}/combo",
    processMethodCombo: "v1/processing-methods-combo",
    provinceCombo: "v1/filter/province",
    referenceCombo: "v1/fa/jobs-profile/reference-combo",
    standardProductCombo: "v1/fa/jobs-profile/standard-product-combo",
    technologySkillCombo:
      "v1/fa/jobs-profile/standard-product/{0}/technology-skill-combo",
    toolsUsedCombo: "v1/fa/jobs-profile/standard-product/{0}/tools-used-combo",
    contentModelReferenceCombo:
      "v1/fa/jobs-profile/content-model-reference-combo",
    jobReferenceCombo: "v1/fa/jobs-profile/reference-combo",
    defaultDashboardCombo: "v1/default-dashboard-combo",
    interviewLocationCombo: "v1/interview_location_combo",
    interviewLocationPlanCombo: "v1/interview-location-plan-combo",
    reportingToolsCombo: "v1/report-data-reporting-tools-combo",
    competencyMatrixCombo: "v1/competency-matrix-combo",
    reportSettingReportIndicatorsCombo:
      "v1/report-setting/{0}/report-indicators-combo",
    tabCombo: "v1/tab-combo",
    parvandehGradeCombo: "v1/parvandeh/{0}/grade-combo",
    hozehGhazayiProvinceCombo: "v1/hozeh_ghazayi_province_combo",
    hozehGhazayiDetailCombo: "v1/hozeh_ghazayi_detail_combo",
    porseshnamehCombo: "v1/fa/porseshnameh/porseshnameh-combo",
    azmoonExecuteAvailablePerson: "v1/azmoon_execute/{0}/available_person",
    azmoonExecuteAvailableOperator: "v1/azmoon_execute/{0}/available_operator",
    personCombo: "v1/person-combo",
    azmoonTermStateCombo: "v1/azmoon_term_state/{0}",
    analysisAlgorithm: "v1/analysis_algorithm_combo",
    orderCombo: "v1/order_combo",
    cooperationParvandehCombo: "v1/cooperation_parvandeh_combo",
    paymentRuleCombo: "v1/payment_rule_combo",
    myFlowAccessCombo: "v1/my-flow-access-combo",
    eventManagementTemplatesCombo: "v1/event-management-templates-combo",
    eventManagementCombo: "v1/event-management-combo",
    exerciseTypeCombo: "v1/center-execute/{0}/exercise-type-combo",
    flowCombo: "v1/flow-combo",
    conversationCategoriesCombo: "v1/my-conversation-categories-combo",
    workContextCategoriesCombo:
      "v1/fa/jobs-profile/work-context-categories-combo/{0}",
    zoneReferenceCombo: "v1/fa/jobs-profile/zone-reference-combo",
    licenseFieldCombo: "v1/fa/markazjazb/license-field-combo/{0}",
    indicatorReferenceCombo: "v1/indicator-reference-combo",
    azmoonCombo: "v1/{0}/{1}/azmoon_combo",
    mySurveyGroupCombo: "v1/my-survey-group",
    personProfilePreview: "v1/person/{0}/profile-preview",
    personProfilePreviewPdf: "v1/person/{0}/profile-preview-pdf",
    parvandeh_report: "v1/parvandeh/{0}/parvandeh_report",
    report_id: "v1/report/{0}",
    enum: "v1/enum",
    attachment_files: "v1/{0}/files/{1}/{2}",
    keyValueAttachment: "v1/{0}/{1}/attachment",
    whats_new_version: "v1/whats_new_version",
    generate_otp_code: "v1/generate_otp_code",
    keyValuePersonContent: "v1/{0}/{1}/person_content",
    reportSettings: "v1/report_settings",
    reportSetting: "v1/report_settings/{0}",
    activities: "v1/{0}/{1}/activity",
    activity: "v1/{0}/{1}/activities/{2}",
    action: "v1/action",
    captcha: "v1/captcha",
    date: "v1/date",
    province_township: "v1/province/{0}/township",
    township_section: "v1/township/{0}/section",
    enumAll: "v1/enum_all",
    attachmentOriginal: "v1/attachment/{0}/original",
    interviewPerson: "v1/interview_location_person",
    parvandehCancelPreviewPdf: "v1/parvandeh-cancel/preview-pdf",
    aftaAuthentication: "v1/afta_authentication",
    checkAftaAuthentication: "v1/auth-check-verify",
    authVerifyByPassword: "v1/auth-verify-by-password",
    generateMobileOtpForMe: "v1/generate-mobile-otp-for-me",
    authVerifyMeByMobile: "v1/auth-verify-me-by-mobile",
    generateEmailOtpForMe: "v1/generate-email-otp-for-me",
    authVerifyMeByEmail: "v1/auth-verify-me-by-email",
    generatePassword: "v1/generate-password",
    mySessionHistory: "v1/my-session-history",
    mySessionHistoryDelete: "v1/my-session-history/{0}/delete",
    azmoonExecuteExamPacks:
      "v1/azmoon_execute/{0}/person/{1}/operator/{2}/reference/{3}",
    attachmentDownload: "v1/attachment/download/{0}",
    attachmentDownload2: "v1/attachment/download_file/{0}",
    termDashboard: "v1/term-dashboard",
    aiAggregatorCompanyCombo: "v1/ai-aggregator-company-combo",
    allExamPack: "v1/exam_pack/all",
    voiceToTextOnline: "v1/voice-to-text-online",

    v2: {
      uploadResourceReport: "v2/fa/report/{0}/{1}/report",
      parvandeh: "v2/parvandeh",
    },
  },
};
